import React, {useState} from "react";
import {
	IconButton,
	Tooltip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button
} from "@material-ui/core";
import {Edit as EditIcon, Delete as DeleteIcon} from "@material-ui/icons";

export default function ActionButtons({row, handleEdit, handleDelete}) {

	return (
		<>
			<Tooltip title="Edit">
				<IconButton
					size="small"
					color="primary"
					onClick={() => handleEdit(row)}
				>
					<EditIcon/>
				</IconButton>
			</Tooltip>
			{!row.is_deleted && handleDelete && (
				<Tooltip title="Delete">
					<IconButton
						size="small"
						color="secondary"
						onClick={() => handleDelete(row)}
					>
						<DeleteIcon/>
					</IconButton>
				</Tooltip>
			)}
		</>
	);
}
